import "./Styles/Login.scss";
import loginImg from "../Images/loginImg.png";
import { Link, Redirect, useHistory } from "react-router-dom";
import { useState } from "react";
import { baseUrl, mainBaseUrl } from "../App";
import axios from "axios";
import loaderimg from "../Images/InsistentTautGodwit-small.gif";
import info from "../Images/information-button.png";
const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loader, setLoader] = useState(false);

  var token;
  const history = useHistory();

  const routeDashboard = () => {
    history.push({
      pathname: "/dashboard",
    });
  };

  const routeAbout = () => {
    history.push({
      pathname: "/about",
    });
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    setLoader(true);
    axios
      .post(
        `${mainBaseUrl}/users/login`,
        {
          email: email,
          password: password,
        },
        {
          headers: {
            "API-Key": baseUrl,
          },
        }
      )
      .then((response) => {
        token = response.data.token;
        localStorage.setItem("token", token);
        setLoader(false);
      })
      .then(routeDashboard)
      .catch((e) => {
        console.log(e);
        setLoader(false);
        // console.log(JSON.stringify(e.response.data));
      });
  };

  if (localStorage.getItem("token")) {
    return <Redirect to="/dashboard" />;
  }

  return loader ? (
    <div className="imgContainer">
      <img className="gif" src={loaderimg} alt="" />
    </div>
  ) : (
    <div className="login">
      <div className="illustration">
        <div className="textArea">
          <h1>Sign In to</h1>
          <h1>
            DSC GHRCE <br /> Certificate
          </h1>
          <h1>Manager</h1>
        </div>
        <div className="image">
          <img src={loginImg} alt="image" />
        </div>
      </div>
      <form className="functionArea">
        <input
          onChange={(event) => setEmail(event.target.value)}
          type="email"
          placeholder="Enter Email Id"
        />
        <input
          onChange={(event) => setPassword(event.target.value)}
          type="password"
          placeholder="Enter password"
        />
        <button onClick={onSubmitHandler} type="submit">
          Sign In
        </button>
        <p>
          <Link to="/forgotPass" style={{ textDecoration: "none" }}>
            <span>Forgot Password</span>
          </Link>
        </p>
        <br />
        <p>
          Don't have account ?{" "}
          <Link to="/register" style={{ textDecoration: "none" }}>
            <span>Register here</span>
          </Link>
        </p>
        <img
          onClick={routeAbout}
          src={info}
          style={{
            width: "1.5rem",
            position: "absolute",
            bottom: "1rem",
            right: "2rem",
            cursor: "pointer",
          }}
        />
      </form>
    </div>
  );
};

export default Login;
